import { render, staticRenderFns } from "./AddFrontPage.vue?vue&type=template&id=6169a5da&"
import script from "./AddFrontPage.vue?vue&type=script&lang=js&"
export * from "./AddFrontPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports